.overview {
  padding: 22px 24px 40px;
}

/* Restored: OverviewItemCard.css and GstInvoiceItem.css `composes: border from` this class. */
.border {
  background: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 6px 18px rgba(120, 30, 30, 0.05);
}

.pagehead {
  margin: 0 0 16px;
}

.pageTitle {
  margin: 0;
  font-family: var(--font-serif);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ib-ink);
}

/* ── shared panel ── */
.panel {
  background: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 6px 18px rgba(120, 30, 30, 0.05);
}

.eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--ib-muted);
}

.sub {
  font-size: 12px;
  color: var(--ib-muted);
  margin-top: 5px;
}

/* numbers always render as bold tabular-lining sans (never serif) */
.num {
  font-variant-numeric: tabular-nums lining-nums;
  letter-spacing: -0.02em;
}

/* ── top row ── */
.top {
  display: grid;
  grid-template-columns: 1.9fr 1fr;
  gap: 15px;
  margin-bottom: 15px;
}

/* ── portfolio hero ── */
.pf {
  composes: panel;
  padding: 20px 22px 18px;
  position: relative;
  overflow: hidden;
}

.val {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.big {
  composes: num;
  font-size: 40px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 0.95;
  color: var(--ib-ink);
}

.change {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: var(--ib-good-soft);
  color: var(--ib-good);
  font-weight: 700;
  font-size: 13px;
  padding: 5px 10px;
  border-radius: 8px;
  margin-bottom: 4px;
  font-variant-numeric: tabular-nums lining-nums;
}

.changeLoss {
  composes: change;
  background: var(--ib-red-soft);
  color: var(--ib-red);
}

.tri {
  font-size: 10px;
}

.compose {
  margin: 18px 0 6px;
}

.bar {
  height: 12px;
  border-radius: 7px;
  overflow: hidden;
  display: flex;
  background: var(--ib-line-2);
}

.bar i {
  height: 100%;
  display: block;
}

.principal {
  background: var(--ib-navy);
}

.gain {
  background: var(--ib-good);
}

.legend {
  display: flex;
  gap: 20px;
  margin-top: 11px;
  flex-wrap: wrap;
}

.li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex: none;
}

.dotPrincipal {
  composes: dot;
  background: var(--ib-navy);
}

.dotGain {
  composes: dot;
  background: var(--ib-good);
}

.lk {
  font-size: 11.5px;
  color: var(--ib-muted);
  font-weight: 600;
}

.lv {
  composes: num;
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ib-ink);
}

.lvGain {
  composes: lv;
  color: var(--ib-good);
}

.kpis {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid var(--ib-line-2);
  margin-top: 16px;
}

.kpi {
  padding: 14px 22px;
}

.kpi + .kpi {
  border-left: 1px solid var(--ib-line-2);
}

.k {
  font-size: 11px;
  color: var(--ib-muted);
  font-weight: 600;
}

.v {
  composes: num;
  font-size: 20px;
  font-weight: 800;
  margin-top: 4px;
  color: var(--ib-ink);
}

.vGood {
  composes: v;
  color: var(--ib-good);
}

.vRed {
  composes: v;
  color: var(--ib-red);
}

/* ── wallet panel ── */
.wl {
  composes: panel;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.amt {
  composes: num;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.03em;
  margin-top: 8px;
  color: var(--ib-ink);
}

.btns {
  display: flex;
  gap: 9px;
  /* push the actions to the bottom of the (tall) wallet panel, next to the note */
  margin-top: auto;
}

.btn {
  flex: 1;
  text-align: center;
  border: 0;
  cursor: pointer;
  font-weight: 700;
  font-size: 13.5px;
  padding: 11px 0;
  border-radius: 9px;
  font-family: inherit;
}

.dep {
  composes: btn;
  background: var(--ib-red);
  color: #ffffff;
}

.dep:hover {
  background: var(--ib-red-d);
}

.wd {
  composes: btn;
  background: var(--ib-panel);
  color: var(--ib-ink);
  border: 1px solid var(--ib-line);
}

.wd:hover {
  border-color: var(--ib-muted);
}

.note {
  margin-top: 0;
  padding-top: 14px;
  font-size: 11.5px;
  color: var(--ib-faint);
  display: flex;
  gap: 7px;
  align-items: flex-start;
}

.noteIcon {
  color: var(--ib-muted);
  font-weight: 800;
}

/* ── transactions panel ── */
.txn {
  composes: panel;
  padding: 16px 22px 18px;
}

.txnHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 12px;
  gap: 10px;
  flex-wrap: wrap;
}

.noTxn {
  text-align: center;
  padding: 22px 0 8px;
  color: var(--ib-muted);
  font-size: 13.5px;
}

.txnTitle {
  margin: 0;
  font-family: var(--font-serif);
  font-size: 17px;
  font-weight: 700;
  color: var(--ib-ink);
}

.cap {
  font-size: 11.5px;
  color: var(--ib-faint);
}

/* ── reversible-withdrawal rows inside the Wallet transactions panel ── */
.pendingList {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pendingItem {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: space-between;
  border: 1px solid var(--ib-line);
  border-radius: 12px;
  padding: 14px 16px;
}

.pendingAmt {
  font-size: 15px;
  font-weight: 800;
  color: var(--ib-ink);
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums lining-nums;
  margin-top: 2px;
}

.pendingWhen {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--ib-ink);
  margin-top: 2px;
}

.reverseBtn {
  margin-left: auto;
  border: 0;
  cursor: pointer;
  background: var(--ib-red);
  color: #ffffff;
  font-weight: 700;
  font-size: 13px;
  padding: 9px 18px;
  border-radius: 8px;
}

.reverseBtn:hover {
  background: var(--ib-red-d);
}

.reverseBtn:disabled {
  background: var(--ib-chip);
  color: var(--ib-faint);
  cursor: not-allowed;
}

/* horizontal scroll instead of clipping the 5 columns on narrow screens */
.tableWrap {
  width: 100%;
  overflow-x: auto;
  margin-top: 8px;
}

.table {
  width: 100%;
  min-width: 620px;
  border-collapse: collapse;
  font-variant-numeric: tabular-nums lining-nums;
}

.table thead th {
  text-align: left;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--ib-muted);
  font-weight: 700;
  padding: 9px 22px;
  background: var(--ib-line-2);
  border-top: 1px solid var(--ib-line);
  white-space: nowrap;
}

.table thead th.rcol {
  text-align: right;
}

.table tbody td {
  padding: 12px 22px;
  border-top: 1px solid var(--ib-line-2);
  font-size: 13px;
  color: var(--ib-ink);
  white-space: nowrap;
  vertical-align: middle;
}

.table tbody td.rcol {
  text-align: right;
}

.amountCell {
  font-weight: 700;
}

/* Reference can be long — truncate with ellipsis rather than blow out the row */
.refCell {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--ib-muted);
}

.status {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  letter-spacing: 0.02em;
}

.stOk {
  background: var(--ib-good-soft);
  color: var(--ib-good);
}

.stPending {
  background: #fdf3e0;
  color: var(--ib-amber);
}

.empty {
  padding: 44px 22px;
  text-align: center;
}

.emptyIc {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: var(--ib-chip);
  display: grid;
  place-items: center;
  margin: 0 auto 12px;
  font-size: 22px;
}

.emptyTitle {
  display: block;
  font-weight: 700;
  font-size: 15px;
  color: var(--ib-ink);
}

.emptyText {
  margin: 5px 0 16px;
  color: var(--ib-muted);
  font-size: 13px;
}

.emptyBtn {
  composes: dep;
  display: inline-block;
  flex: none;
  padding: 10px 20px;
}

@media only screen and (max-width: 820px) {
  .top {
    grid-template-columns: 1fr;
  }
}

/* Phones: match the 14px side padding Portfolio/Profile use, and stack the
   3-up KPI strip (it overflows) with top dividers */
@media only screen and (max-width: 550px) {
  .overview {
    padding: 16px 14px 40px;
  }
  .kpis {
    grid-template-columns: 1fr;
  }
  .kpi + .kpi {
    border-left: 0;
    border-top: 1px solid var(--ib-line-2);
  }
}
